import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@anihis/shared/src/services/authentication.service';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  imports: [CommonModule, TranslocoModule],
  standalone: true,
})
export class AccessDeniedComponent {
  private auth = inject(AuthenticationService);
  private router = inject(Router);

  message = 'You do not have access to this portal with your account.';

  async logout() {
    await this.auth.logout();
    // Navigate to login after clearing tokens
    this.router.navigate(['/login']);
  }
}
